import { render, staticRenderFns } from "./card-gallery.vue?vue&type=template&id=96140ff6&scoped=true"
import script from "./card-gallery.vue?vue&type=script&lang=js"
export * from "./card-gallery.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/sass/commponents/gallery-card.scss?vue&type=style&index=0&id=96140ff6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96140ff6",
  null
  
)

export default component.exports